module.exports = __webpack_public_path__ + "static/stephanie-74cfe53d31962910b20b71d76e2a89ef.png";